import { Component } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BerichtForm from './pages/BerichtForm';
import FotoKarte from './pages/FotoKarte';
import Admin from './pages/Admin';

class ErrorBoundary extends Component {
  constructor(p) { super(p); this.state = { err: null }; }
  static getDerivedStateFromError(err) { return { err }; }
  render() {
    if (this.state.err) return (
      <div style={{ padding: 24, fontFamily: 'monospace', color: '#c0392b', whiteSpace: 'pre-wrap' }}>
        Fehler beim Anzeigen: {String(this.state.err?.message || this.state.err)}
      </div>
    );
    return this.props.children;
  }
}

function PrivateRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !user.ist_admin) return <Navigate to="/" />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/bericht/:id" element={<PrivateRoute><BerichtForm /></PrivateRoute>} />
          <Route path="/karte" element={<PrivateRoute><ErrorBoundary><FotoKarte /></ErrorBoundary></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute adminOnly><Admin /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
